import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { PageTabRail } from '@interxfi/app-components/components/page-tab-rail/page-tab-rail';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../components/router/router-tabbed-navigation';
import { BatchOrderSubmitDrawer } from '../../../../../../../features/order/batch/batch-order-submit-drawer';
import { BatchOrdersTable } from '../../../../../../../features/order/batch/batch-orders-table';
import { getPageHead } from '../../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/order/equity/batch/_batch/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.OrdersEquities,
      label: 'Batch Orders',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.OrdersEquities>,
  head: () => getPageHead('Batch Orders'),
  component: BatchOrdersList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <BatchOrderSubmitDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Batch Order" size="small" />} />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.OrdersEquities}
    />
  );
}

function BatchOrdersList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section>
        <BatchOrdersTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
